import { html } from 'lit';
import { RAINBOW_COLORS } from './constants.js';
import { isEven } from '@outbook/numbers';
import { NYAN_CAT_DATA_URL } from './nyan-cat-data.js';

export function themeNyanCat() {
  return html`
    <div class="progress__rainbow">
      ${Array.from(Array(5)).map((column, index) => {
        return html`
          <div
            class="progress__rainbow-column column-${
              isEven(index) ? 'even' : 'odd'
            }"
          >
            ${RAINBOW_COLORS.map(color => {
              return html`<div
                class="progress__rainbow-line line-${color}"
              ></div>`;
            })}
          </div>
        `;
      })}
    </div>
    <img src="${NYAN_CAT_DATA_URL}" alt="" aria-hidden="true" />
  `;
}
